import { useLayoutEffect } from "react";
import {Layout} from "../../components/common/Layout"
import { DispatchersTable } from "../../components/dispatchers/DispatchersTable";

export const DispatchersPage = () => {

    const title = "Диспетчеры";
    useLayoutEffect(() => {
        document.body.style.backgroundColor = "white"
        document.body.style.backgroundImage = "";
   });
    return (
        <Layout title={title}>
            <DispatchersTable/>
        </Layout>
    )
}